import { BookOutlined, HomeOutlined, InfoCircleOutlined, NotificationOutlined, TeamOutlined } from '@ant-design/icons';
import { Layout } from '@lib/common';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var CLASS_PAGES = ['dashboard', 'members', 'assignments', 'announcements', 'information'];
export var CLASS_SECTION_ROUTE = '/bricks/classes/[id]/[...section]';
export function getClassPage(pathname, legacyTab) {
  if (pathname.includes('/students/') || getClassStudentId(legacyTab)) return 'members';
  var querySection = Array.isArray(legacyTab) ? legacyTab[0] : legacyTab;
  var section = pathname.split('/').pop();
  return CLASS_PAGES.find(function (page) {
    return page === section;
  }) || CLASS_PAGES.find(function (page) {
    return page === querySection;
  }) || 'dashboard';
}
export function getClassPagePath(classId) {
  var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'dashboard';
  return "/bricks/classes/".concat(encodeURIComponent(classId), "/").concat(page);
}
export function getClassPageRoute(classId, section, name) {
  return {
    pathname: CLASS_SECTION_ROUTE,
    query: {
      id: classId,
      section: [section],
      name: name,
      level: 2
    }
  };
}
export function getClassStudentId(section) {
  return Array.isArray(section) && section.length === 2 && section[0] === 'students' && typeof section[1] === 'string' && section[1] ? section[1] : undefined;
}
export function getClassStudentRoute(classId, studentId, name) {
  return {
    pathname: CLASS_SECTION_ROUTE,
    query: {
      id: classId,
      section: ['students', studentId],
      name: name,
      level: 3
    }
  };
}
export function isClassSectionLink(href, classId) {
  return !!classId && CLASS_PAGES.some(function (page) {
    return href.split('?')[0].endsWith(getClassPagePath(classId, page));
  });
}
var HeaderContent = styled.div.withConfig({
  displayName: "class-navigation__HeaderContent",
  componentId: "sc-1jauq53-0"
})(["display:flex;align-items:center;gap:12px;flex:1;min-width:0;"]);
var HeaderDetails = styled.div.withConfig({
  displayName: "class-navigation__HeaderDetails",
  componentId: "sc-1jauq53-1"
})(["flex:1;min-width:0;display:flex;align-items:center;"]);
export function ClassPageLayout(_ref) {
  var children = _ref.children,
      header = _ref.header,
      subtitle = _ref.subtitle,
      activePage = _ref.activePage,
      labels = _ref.labels,
      onNavigate = _ref.onNavigate,
      _ref$showMenu = _ref.showMenu,
      showMenu = _ref$showMenu === void 0 ? true : _ref$showMenu,
      mainMenu = _ref.mainMenu;
  var icons = {
    dashboard: /*#__PURE__*/_jsx(HomeOutlined, {}),
    members: /*#__PURE__*/_jsx(TeamOutlined, {}),
    assignments: /*#__PURE__*/_jsx(BookOutlined, {}),
    announcements: /*#__PURE__*/_jsx(NotificationOutlined, {}),
    information: /*#__PURE__*/_jsx(InfoCircleOutlined, {})
  };

  var classLayout = /*#__PURE__*/_jsxs(Layout, {
    embedded: true,
    children: [showMenu && /*#__PURE__*/_jsx(Layout.Sider, {
      forceCollapsed: false,
      collapsible: false,
      selectedKeys: [activePage],
      items: CLASS_PAGES.map(function (page) {
        return {
          key: page,
          label: labels[page],
          icon: icons[page],
          onClick: function onClick() {
            return onNavigate(page);
          }
        };
      })
    }), /*#__PURE__*/_jsx(Layout.Content, {
      padding: "0px",
      children: children
    })]
  });

  return /*#__PURE__*/_jsxs(Layout, {
    mobileFullWidth: true,
    children: [/*#__PURE__*/_jsx(Layout.Header, {
      children: /*#__PURE__*/_jsxs(HeaderContent, {
        children: [/*#__PURE__*/_jsx(Layout.Logo, {
          subTitle: subtitle,
          logoSrc: "/images/Favicon.svg",
          logoTitleSrc: "/icons/digi-logo.svg",
          logoWidth: 40,
          logoHeight: 40,
          forceCollapsed: false
        }), /*#__PURE__*/_jsx(HeaderDetails, {
          children: header
        })]
      })
    }), mainMenu && /*#__PURE__*/_jsx(Layout.Sider, {
      forceCollapsed: true,
      collapsible: false,
      items: mainMenu.items,
      bottomItems: mainMenu.bottomItems,
      selectedKeys: mainMenu.selectedKeys,
      defaultOpenKeys: mainMenu.defaultOpenKeys,
      topContent: mainMenu.topContent
    }), /*#__PURE__*/_jsx(Layout.Content, {
      padding: 0,
      children: classLayout
    })]
  });
}
export function buildClassBreadcrumb(_ref2) {
  var pathname = _ref2.pathname,
      section = _ref2.section,
      menu = _ref2.menu,
      classId = _ref2.classId,
      className = _ref2.className,
      _ref2$localePrefix = _ref2.localePrefix,
      localePrefix = _ref2$localePrefix === void 0 ? '' : _ref2$localePrefix,
      labels = _ref2.labels;
  var isClassDetail = pathname.startsWith('/bricks/classes/[id]');
  var isStudentDetail = pathname.includes('/students/[studentId]') || !!getClassStudentId(section);
  if (!(pathname === '/bricks' && menu === 'classes') && !isClassDetail) return undefined;
  var items = [{
    label: labels.home,
    href: "".concat(localePrefix, "/bricks")
  }, {
    label: labels.classes
  }];
  if (!classId || !isClassDetail) return items;
  items[1].href = "".concat(localePrefix, "/bricks?menu=classes&level=1");
  items.push({
    label: className || labels.classFallback,
    href: "".concat(localePrefix).concat(getClassPagePath(classId))
  });

  if (isStudentDetail) {
    items.push({
      label: labels.students,
      href: "".concat(localePrefix).concat(getClassPagePath(classId, 'members'))
    });
  } else if (labels.sections) {
    items.push({
      label: labels.sections[getClassPage(pathname, section)]
    });
  }

  return items;
}